module.exports = __webpack_public_path__ + "img/IT0004218607434.b90860d3.png";